import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const addressesIdentity = defineEntityIdentity({
	definitionKey: "addresses",
	pageKey: "addresses",
	nameSingular: "address",
	namePlural: "addresses",
	relationKey: "address",
	auditKey: "addresses",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.addresses.readAll, audience: "allMembers" },
		create: { ...PERMISSIONS.addresses.createAll, audience: "allMembers" },
		update: { ...PERMISSIONS.addresses.updateAll, audience: "allMembers" },
		delete: { ...PERMISSIONS.addresses.deleteAll, audience: "allMembers" }
	}
});
